import { render, staticRenderFns } from "./ProductDocIcon.vue?vue&type=template&id=0d07d422"
import script from "./ProductDocIcon.vue?vue&type=script&lang=ts"
export * from "./ProductDocIcon.vue?vue&type=script&lang=ts"
import style0 from "./ProductDocIcon.vue?vue&type=style&index=0&id=0d07d422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports